import { render, staticRenderFns } from "./BTextEditor.vue?vue&type=template&id=6c165829&scoped=true"
import script from "./BTextEditor.vue?vue&type=script&lang=js"
export * from "./BTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c165829",
  null
  
)

export default component.exports